export const getCsrfToken = (): string => {
    const metas = document.getElementsByTagName('meta');
    const token = Array.from(metas)
        .find((meta) => meta.getAttribute('name') === 'eccube-csrf-token');
    return token?.getAttribute('content') ?? '';
};
